import { faInfoCircle, faPlus } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Button, DashboardModule, Form, IconWithMenu, Link, Text,
} from '@domain-group/suit-theme'

import { digObject, handleCallbackAction, toggleArray } from '@domain-group/javascript-utils'

import { UseUserPayload } from '@hooks/useUser'

import { UserModel } from '@models/types'

import UserListItem from './UserListItem'

interface removeAgentUserParams {
  assignedAgentIds: number[],
  updateFn: UseUserPayload['callbacks']['updateUser'],
  user: UserModel,
  userActableId: number,
}

const removeAgentUser = (params: removeAgentUserParams) => {
  const {
    assignedAgentIds,
    updateFn,
    user,
    userActableId,
  } = params

  const updatedAssignedAgentIds = toggleArray(assignedAgentIds, userActableId)

  const updateUserPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: { id: user.id, assigned_agent_ids: updatedAssignedAgentIds, ebu_admin: true },
    requestOptions: {
      include_image_sizes: true,
      include_user_ebu_assigned_users: true,
      include_user_image: true,
      include_user_type: true,
    },
  }

  return handleCallbackAction(updateUserPayload)
}

interface handleUpdateUserParams {
  ebuAdminValue: 'true' | 'false',
  id: number,
  updateFn: (payload: object) => Promise<object>,
}

const handleUpdateUser = (params: handleUpdateUserParams) => {
  const {
    ebuAdminValue,
    id,
    updateFn,
  } = params

  const updateUserPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: { id, ebu_admin: ebuAdminValue === 'true', assigned_agent_ids: [] },
    requestOptions: {
      include_user_ebu_assigned_users: true,
      include_user_type: true,
    },
    toastText: 'User Updated',
  }

  // @ts-expect-error TS2345
  handleCallbackAction(updateUserPayload)
}

interface EBUSettingsProps {
  callbacks: {
    updateUser: () => void,
  },
  userPayload: UseUserPayload,
}

const EBUSettings = (props: EBUSettingsProps) => {
  const { callbacks: { updateUser: updateFn }, userPayload } = props

  const {
    callbacks: { manageEbuAssignedAgentsModal },
    user,
    user: { id, ebu_assigned_user_ids },
  } = userPayload

  const assignedAgentIds = digObject(user, 'actable.assigned_agent_ids', [])

  const ebuAdmin = digObject(user, 'actable.ebu_admin', false)

  return (
    <DashboardModule
      title="EBU Admin Settings"
      boxProps={{ marginBottom: 'large' }}
      headerRight={(
        <IconWithMenu
          icon={(
            <Link greyLink>
              <FontAwesomeIcon icon={faInfoCircle} />
            </Link>
          )}
        >
          {/*
           // @ts-expect-error TS2741 */}
          <IconWithMenu.Menu closeOnClick>
            <Text color="bodyFontLightColor" padding="large" width={300}>
              An EBU admin is restricted to working on campaigns of only the agents they are assigned to. If
              you enable EBU admin and assign an agent you&apos;ll lose access to the whole agencies campaigns.
            </Text>
          </IconWithMenu.Menu>
        </IconWithMenu>
      )}
    >
      <Box flexDirection="column" padding="large">
        <Form.Field label="Is user an EBU Admin?">
          <select
            name="ebu_admin"
            onChange={e => handleUpdateUser({
              // @ts-expect-error TS2322
              id, ebuAdminValue: e.target.value, updateFn,
            })}
            value={ebuAdmin}
          >
            <option value="false">No</option>
            <option value="true">Yes</option>
          </select>
        </Form.Field>

        {ebuAdmin && (
          <>
            <Box flexDirection="column">
              {ebu_assigned_user_ids?.length > 0 && ebu_assigned_user_ids?.map((userId: number) => userId && (
              <UserListItem
                callbacks={{
                  removeAgentUser: (userActableId: UserModel) => removeAgentUser({
                    // @ts-expect-error TS2322
                    userActableId, userId, assignedAgentIds, user, updateFn,
                  }),
                }}
                key={userId}
                userId={userId}
              />
              ))}
            </Box>

            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => manageEbuAssignedAgentsModal()}
              size="medium"
              // @ts-expect-error TS2322
              marginTop={assignedAgentIds.length > 0 ? 0 : 'medium'}
            >
              Manage Agents
            </Button>
          </>
        )}
      </Box>
    </DashboardModule>
  )
}

export default EBUSettings
